// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


// import React from "react";
// import ReactDOM from "react-dom/client";
// import App from "./App";
// import { GlobalProvider } from "./context/globalContext"; // Ensure correct import path
// import "bootstrap/dist/css/bootstrap.min.css"; // Ensure Bootstrap is loaded
// import "bootstrap/dist/js/bootstrap.bundle.min"; // Ensure Bootstrap JS is loaded
// import "bootstrap-icons/font/bootstrap-icons.css"; // Ensure Bootstrap Icons are loaded
// import { BrowserRouter as Router } from "react-router-dom"; // React Router

// const root = ReactDOM.createRoot(document.getElementById("root")!);

// root.render(
//   <React.StrictMode>
//     <GlobalProvider>
//       <Router>
//         <App />
//       </Router>
//     </GlobalProvider>
//   </React.StrictMode>
// );

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { GlobalProvider } from "./context/globalContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <GlobalProvider>
        <App />
      </GlobalProvider>
    </BrowserRouter>
  </React.StrictMode>
);
